import {CoreDI, IAnimation, inject, ObjectBuilder, UpdateManager} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {GameConfig, IReelsScaleService} from '@gongxigames/framework/slot/types';
import {ReelConstants} from '@gongxigames/framework/slot/utils';
import {View} from '@gongxigames/framework/slot';

export class AnticipatorView extends View {
    public static readonly NAME: symbol = Symbol('AnticipatorView');
    public static layer = LAYERS.POPUPS;

    public static readonly STARTED: symbol = Symbol('STARTED');
    public static readonly FINISHED: symbol = Symbol('FINISHED');

    protected _updater: UpdateManager = new UpdateManager(true);

    @inject(DI.ReelsScaleService)
    protected _reelsScaleService!: IReelsScaleService;

    @inject(CoreDI.GameConfig)
    protected _gameConfig!: GameConfig;

    public init(): void {
        super.init();

        this.updateManager.add(this._updater);
    }

    public play(reelIndex: number): Promise<void> {
        let animation: IAnimation;

        /*
        * Trying to create spine animation, if not - trying to create sequence animation
        * One of those animations should be implemented in game studio
        * */
        try {
            animation = this.spineUtils.createSpineAnimation(this.spineName, this.animationName);
            animation.container.x = ReelConstants.REELS[reelIndex].symsPositions[0].x + ReelConstants.SYMBOL_SLOT.width / 2;
            animation.container.y = this._gameConfig.mainFrame.height / 2;
        } catch (e) {
            animation = this.objectBuilder.buildAnimation(ObjectBuilder.resources.game_sprite.anticipator);
            animation.container.x = reelIndex * ReelConstants.SYMBOL_SLOT.width;
        }

        return new Promise<void>(resolve => {
            animation.setOnComplete(() => {
                this.emit(AnticipatorView.FINISHED, reelIndex);
                resolve();
            });
            animation.start();
            this._updater.add(animation);
            this.container.addChild(animation.container);
            this.emit(AnticipatorView.STARTED, animation.getDuration());
        });

    }

    public stopAnticipationAnimation(): void {
        this._updater.removeAll();
        this.container.children.length = 0;
    }

    public onOrientationChanged(): void {
        super.onOrientationChanged();

        this._reelsScaleService.scaleByCurrentScreenOrientation(this.container);
    }

    public get spineName(): string {
        return 'anticipator';
    }

    public get animationName(): string {
        return 'longspin';
    }
}
